import { BaseRequest } from './BaseRequest';

export class TransactionRequest extends BaseRequest {
    OrganizationId: string;
    WalletId: string;
    Type: string;
    Amount: number;
}